import { ASSET_URL } from "@api";

/**
 * @param {unknown} uploaded
 * @returns {string}
 */
function uploadPathFromResponse(uploaded) {
  if (typeof uploaded === "string") {
    return uploaded.trim();
  }
  if (!uploaded || typeof uploaded !== "object") {
    return "";
  }

  const record = /** @type {Record<string, unknown>} */ (uploaded);
  const candidates = [record.path, record.url, record.data, record.fileName, record.id];

  for (const candidate of candidates) {
    if (typeof candidate === "string" && candidate.trim()) {
      return candidate.trim();
    }
  }

  return "";
}

/**
 * @param {unknown} uploaded
 * @param {string} fileName
 * @returns {string}
 */
export function assetRefFromUpload(uploaded, fileName) {
  const base = uploadPathFromResponse(uploaded);

  if (!base) return "";
  if (base.includes("__")) return base;
  return `${base}__${fileName}`;
}

/**
 * @param {string} assetRef
 * @returns {string}
 */
export function displayFileNameFromAssetRef(assetRef) {
  if (!assetRef) return "";
  return assetRef.includes("__") ? assetRef.split("__").slice(1).join("__") : assetRef;
}

/**
 * @param {string} assetRef
 * @returns {string}
 */
export function assetRefStoragePath(assetRef) {
  if (!assetRef) return "";
  return assetRef.includes("__") ? assetRef.split("__")[0] : assetRef;
}

/**
 * Build an asset-handler download URL from an opaque assetRef.
 * Uses the full ref (e.g. `uuid__originalFileName.pdf`) — same contract as product images.
 *
 * @param {string} assetRef
 * @returns {string|null}
 */
export function resolveAssetRefDownloadUrl(assetRef) {
  const ref = String(assetRef ?? "").trim();
  if (!ref) return null;
  if (/^https?:\/\//i.test(ref)) return ref;
  if (!ASSET_URL) return null;

  const path = ref.replace(/^\//, "");
  return `${ASSET_URL}/${encodeURI(path)}`;
}
